import React from 'react';
import { toast } from 'sonner';
import { Checkbox } from './ui/checkbox';
import { useCompare, COMPARE_MAX } from '../lib/compareStore';

export const CompareToggle = ({ item, testId }) => {
  const { has, toggle } = useCompare();
  const checked = has(item.slug);
  const onChange = () => {
    if (!toggle(item)) toast.error(`You can compare up to ${COMPARE_MAX} modules`);
  };
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer select-none text-xs font-mono uppercase tracking-wider text-[#94A3B8] hover:text-white transition-colors" data-testid={testId}>
      <Checkbox checked={checked} onCheckedChange={onChange} className="border-[#475569] data-[state=checked]:bg-cyan-500 data-[state=checked]:border-cyan-500" />
      Compare
    </label>
  );
};

export default CompareToggle;
